import React from 'react';
import Form from '@rjsf/core';
import Button from "react-bootstrap/Button";
import MonacoEsSearchWidget from "../../../../Various/rjsf/manacoEsSearchWidget";

const CampaignForm = ({ 
    campaign, 
    setCampaign, 
    schema, 
    uiSchema, 
    onSave, 
    onPublish,
    wsProvider 
}) => {
    const widgets = {
        monacoes: MonacoEsSearchWidget,
    };

    return (
        <div className='row'>
            <div className='col-12 campaign_form'>
                <Form
                    key={campaign.campaign_id} // Add key to force re-render when client changes
                    schema={schema}
                    uiSchema={uiSchema}
                    formData={campaign}
                    onSubmit={onSave}
                    onChange={(data) => setCampaign(data.formData)}
                    widgets={widgets}
                />
                <Button onClick={onPublish}>Publish</Button>
            </div>
        </div>
    );
};

export default CampaignForm; 